import React from 'react';

const ITServicesProjects = () => {
  return (
    <main style={{ padding: 40, minHeight: '60vh' }}>
      <h1>AILYT IT Services — Projects / Case Studies</h1>
      <p>Portfolio of completed projects including Real Health App, Insurance Demos, and Sample MVPs.</p>
    </main>
  );
};

export default ITServicesProjects;
